import React, { useEffect, useState } from 'react';
import {Header, NewHeader, UserHeader} from './Header';
import { Outlet, createBrowserRouter, RouterProvider, useNavigate, Link, useLocation } from 'react-router-dom';
import { Spacer, DragNDrop, EmptyElement, BackButton, PageNotFound, Spacer100, Spacer10, ConfirmNewCase, Spacer25 } from './Utils';
import { SpanishCitizenship, StudentStay, StudentStayRenewal, NonLucrativeResidencyRenewal, AuxToResidence} from './procedures/immigration_and_citizenship';
import { ArraigoSocial } from './procedures/arraigo_social';
import { DocumentsGridPopup, LogoutPopup, SubmissionSuccessful, SubmitApplicationPopup } from './Popups';
import strs from './strings'
import Documents from './Documents';
import Profile from './Profile';
import { LegalDocs, LegalNotice, PrivacyPolicy, TermsOfServiceGeneral, TermsOfServiceServicePack } from './LegalNotice';
import Case from './Case';
import { NativeTypes } from 'react-dnd-html5-backend';
import { ComingSoon, ForgotPassword, LoginPage, ResetPasswordRedirect, SignUp } from './Login';

//Material UI Imports
import { AddOutlined, ContactPage, ExitToApp, HelpOutline, HomeOutlined, InsertDriveFile, InsertDriveFileOutlined, MenuOutlined, NotificationImportant, NotificationImportantOutlined, Notifications, NotificationsOutlined, PersonOutline, Spa } from '@mui/icons-material';
import CaseNotifications from './Notifications'; 
import { Box, useMediaQuery } from '@mui/system';
import zIndex from '@mui/material/styles/zIndex';
import { Icon, IconButton, Typography } from '@mui/material';
import { useAuth } from './context';
import { getFirestoreCollection, getUser } from './firestore';
import { auth } from './firebase';
import { nanoid } from 'nanoid';
import Contacto from './Contact';
import studySvg from './imgs/study.svg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faFlag, faSun, faMoneyBill1, faMoneyBillAlt } from '@fortawesome/free-regular-svg-icons';
import { faBriefcase, faGraduationCap, faPeopleArrows, faPeopleRoof, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { DummyPDFGen, MyPDFDownloadLink } from './pdf/PDFDownloader';
import { ComEmpleo } from './pdf/PDFTemplates';
import { PrivacyPolicyDialog, TOSDialog } from './tos-dialog';
import { Faq } from './Faq';
import { ScrollToTop } from './utilFunctions';
import { Test } from './Test';
import { ArraigoSociolaboral } from './procedures/arraigo_sociolaboral';
import { ArraigoSegundaOportunidad } from './procedures/arraigo_segunda_oportunidad';
import { ArraigoSocioformativo } from './procedures/arraigo_socioformativo';
import { ArraigoFamiliar } from './procedures/arraigo_familiar';
import { Regularization2026 } from './procedures/regularization_2026';

const caseIcons = {
	auxToResidence: faClipboard,
	studentStay: faClipboard,
	studentStayRenewal: faRotateRight,
	studentStayWork: faClipboard,
	studentRenewalAndWork: faRotateRight,
	arrigoSocialAndWork: faMoneyBillAlt,
	nonLucrativeResidencyRenewal: faSun,
	spanishCitizenship: faFlag,
	arraigoSocial: faPeopleArrows,
	arraigoSociolaboral: faBriefcase,
	arraigoSegundaOportunidad: faSun,
	arraigoSocioformativo: faGraduationCap,
	arraigoFamiliar: faPeopleRoof

}

const caseIconStyles = {
	auxToResidence: 'study-icon',
	studentStay: 'study-icon',
	studentStayRenewal: 'study-icon',
	studentStayWork: 'money-icon',
	studentRenewalAndWork: 'money-icon',
	arrigoSocialAndWork: 'money-icon',
	nonLucrativeResidencyRenewal: 'live-icon',
	spanishCitizenship: 'citizenship-icon',
	arraigoSocial: 'arraigo-social-icon',
	arraigoSociolaboral: 'arraigo-sociolaboral-icon',
	arraigoSegundaOportunidad: 'arraigo-segunda-oportunidad-icon',
	arraigoSocioformativo: 'arraigo-socioformativo-icon',
	arraigoFamiliar: 'arraigo-familiar-icon',
}

const caseIconPaddings = {
	auxToResidence: 'clipboard-icon-padding',
	studentStay: 'clipboard-icon-padding',
	studentStayRenewal: 'round-icon-padding',
	studentStayWork: 'clipboard-icon-padding',
	studentRenewalAndWork: 'round-icon-padding',
	arraigoSocial: 'round-icon-padding',
	arrigoSocialAndWork: 'round-icon-padding',
	nonLucrativeResidencyRenewal: 'round-icon-padding',
	spanishCitizenship: 'flag-icon-padding',
	arraigoSocial: 'round-icon-padding',
	arraigoSociolaboral: 'round-icon-padding',
	arraigoSegundaOportunidad: 'round-icon-padding',
	arraigoSocioformativo: 'round-icon-padding',
	arraigoFamiliar: 'round-icon-padding',

}

let lang = strs.en;
let curProcedure = EmptyElement();

const router = createBrowserRouter([
	{
		path: '/coming-soon',
		element: <ComingSoon />
	},
	{
		path: '/login',
		element: <LoginPage />
	},
	{
		path: '/sign-up',
		element: <SignUp />
	},
	{
		path: '/forgot-password',
		element: <ForgotPassword />
	},
	{
		path: '/reset-password',
		element: <ResetPasswordRedirect />,
	},
	{
		path: '/',
		element: <SidebarLayout />,
		children: [
			{
				path: '/',
				element: <AccountLanding />,
				errorElement: <PageNotFound />
			},
			{
				path:'/test',
				element: <Test />
			},
			{
				path: '/available-procedures',
				element: <AvailableProcedures />,
			},
			{
				path: '/student-stay-options',
				element: <StudentStayOptions />,
			},
			{
				path: '/residency-options',
				element: <ResidencyOptions />,
			},
			{
				path: '/confirm-new-case',
				element: <ConfirmNewCase />
			},
			{
				path: '/aux-to-residence',
				element: <AuxToResidence />
			},
			{
				path: '/student-stay-initial',
				element: <StudentStay />,
			},
			{
				path: '/student-stay-renewal',
				element: <StudentStayRenewal />
			},
			{
				path: '/arraigo-social',
				element: <ArraigoSocial />
			},
			{
				path: '/regularization-2026',
				element: <Regularization2026 />
			},
			{
				path: '/arraigo-sociolaboral',
				element: <ArraigoSociolaboral />
			},
			{
				path: '/arraigo-segunda-oportunidad',
				element: <ArraigoSegundaOportunidad />
			},
			{
				path: '/arraigo-socioformativo',
				element: <ArraigoSocioformativo />
			},
			{
				path: '/arraigo-familiar',
				element: <ArraigoFamiliar />
			},
			{
				path: '/non-lucrative-residency-renewal',
				element: <NonLucrativeResidencyRenewal />
			},
			{
				path: '/spanish-citizenship',
				element: <SpanishCitizenship />
			},
			{
				path: '/homologate-secondary-school',
				element: <PageNotFound />,
			},
			{
				path: '/homologate-bachelors-degree',
				element: <PageNotFound />,
			},
			{
				path: 'homologate-masters-degree',
				element: <PageNotFound />
			},
			{
				path: '/faq',
				element: <Faq />
			},
			{
				path: '/documents',
				element: <Documents />
			},
			{
				path: '/notifications',
				element: <CaseNotifications />
			},
			{
				path: '/profile',
				element: <Profile />
			},
			{
				path: '/legal',
				element: <LegalDocs />
			},
			{
				path: '/privacy-policy',
				element: <PrivacyPolicy />
			},
			{
				path: '/legal-notice',
				element: <LegalNotice />
			},
			{
				path: '/privacy-policy',
				element: <PrivacyPolicy />
			},
			{
				path: 'terms-of-service-general',
				element: <TermsOfServiceGeneral />
			},
			{
				path: 'terms-of-service-service-pack',
				element: <TermsOfServiceServicePack />
			},
			{
				path: 'tos-dialog',
				element: <TOSDialog />
			},
			{
				path: 'privacy-policy-dialog',
				element: <PrivacyPolicyDialog />
			},
			{
				path: '/submission-successful',
				element: <SubmissionSuccessful />
			},
			{
				path: '/cases/*',
				element: <Case />
			},
			{
				path: '/contact',
				element: <Contacto />
			},
			{
				path:'/pdf',
				element: <MyPDFDownloadLink />
			},
			{
				path: '/dummypdf',
				element: <DummyPDFGen />
			},
			{
				path: 'com-empleo',
				element: <ComEmpleo />
			},
			{
				path: '/documents-grid-popup',
				element: <DocumentsGridPopup />
			}
		],
	}

]);


function Help() {
	return(
	<div>
		<BackButton />
		<Spacer />
		<h1 className='primary-title'>{lang.help}</h1>
		<Spacer100 />
		<h2 className='primary-title-center'>{lang.faq}</h2>
	</div>

	);
}


export function StudentStayOptions(props) {
	const navigate = useNavigate();

	return(
	<div>
		<BackButton />
		<Spacer />
		<h2 className='primary-title'>{lang.studentStayOptions}</h2>
		<Spacer />
		<h2 className='secondary-title'>{lang.stayInSpain}</h2>
		<Spacer />
		<div className='button-row animated-div'>
			<button className='button-row__large-btn'
				onClick={() => navigate('/student-stay-initial', {state: {confirmCase: true}})}
			>
				<div>
					<FontAwesomeIcon icon={faClipboard} className='clipboard-icon-padding study-icon' />
					{lang.studentStay}
				</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.caseTypeDescriptions.studentStay}</p>
				</div>
			</button>
			<button className='button-row__large-btn'
				onClick={() => navigate('/student-stay-renewal', {state: {confirmCase: true}})}
			>
				<div>
					<FontAwesomeIcon icon={faRotateRight} className='study-icon round-icon-padding' />
					{lang.studentStayRenewal}
				</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.caseTypeDescriptions.studentStayRenewal}</p>
				</div>
			</button>
		</div>
	
		<Spacer100 />
		<h2 className='secondary-title'>{lang.stayAndWorkInSpain}</h2>
		<Spacer />
		<div className='button-row animated-div'>
			<button className='button-row__large-btn'
				onClick={() => navigate('/student-stay-initial')}
			>
				<div>
					<FontAwesomeIcon icon={faClipboard} className='money-icon clipboard-icon-padding' />
					{lang.studentStay}
				</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.caseTypeDescriptions.studentStayWork}</p>
				</div>

			</button>
			<button className='button-row__large-btn'
				onClick={() => navigate('/student-stay-renewal')}
			>
				<div>
					<FontAwesomeIcon icon={faRotateRight} className='money-icon round-icon-padding' />
					{lang.studentStayRenewal}
				</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.caseTypeDescriptions.studentRenewalAndWork}</p>
				</div>

			</button>
		</div>




	</div>
	);
}

export function ResidencyOptions() {
	const navigate = useNavigate();

	return (
	<div>
		<BackButton />
		<Spacer />
		<h2 className='secondary-title'>{lang.residencyOptions}</h2>
		<Spacer />
		<h2 className='primary-title-center'>{lang.residencyInSpain}</h2>
		<Spacer />
		<div className='button-row animated-div'>

			<button className='button-row__large-btn bg-orange'
				onClick={() => navigate('/non-lucrative-residency-renewal')}
			>
				<div>
					<FontAwesomeIcon icon={faRotateRight} className='round-icon-padding' />
					<span style={{color: 'white'}}>{lang.nonLucrativeRenewal}</span>
				</div>
				<Spacer100 />
				<div>
					<p className='larger-font' style={{color: 'white'}}>{lang.caseTypeDescriptions.nonLucrativeResidencyRenewal}</p>
				</div>
			</button>
		</div>

		<Spacer100 />
		<h2 className='primary-title-center'>{lang.workInSpain}</h2>
		<Spacer />
		<div className='button-row animated-div'>

			<button className='button-row__large-btn bg-orange'
				onClick={() => navigate('/arraigo-social')}
			>
				<div>
					<FontAwesomeIcon icon={faPeopleArrows} className='round-icon-padding' />
					<span style={{color: 'white'}}>{lang.arraigoSocial}</span>
					<p className='quad-title' style={{color: 'white'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({lang.caseTypes.arraigoSocial})</p>
				</div>
				<div>
					<p className='larger-font' style={{color: 'white'}}>{lang.caseTypeDescriptions.arraigoSocial}</p>
				</div>
			</button>

			<button className='button-row__large-btn bg-blue'
				onClick={() => navigate('/arraigo-sociolaboral')}
			>
				<div>
					<FontAwesomeIcon icon={faBriefcase} className='round-icon-padding' />
					<span style={{color: 'white'}}>{lang.arraigoSociolaboral}</span>
					<p className='quad-title' style={{color: '#ddd'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({lang.caseTypes.arraigoSociolaboral})</p>
				</div>
				<Spacer />
				<div>
					<p className='larger-font' style={{color: 'white'}}>{lang.caseTypeDescriptions.arraigoSociolaboral}</p>
				</div>
			</button>

			<button className='button-row__large-btn bg-red'
				onClick={() => navigate('/arraigo-segunda-oportunidad')}
			>
				<div>
					<FontAwesomeIcon icon={faSun} className='round-icon-padding' />
					<span style={{ fontSize: '1.3rem', color: 'white' }}>Arraigo de Segunda &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Oportunidad</span>
					<p style={{ fontSize: '1.2rem', fontWeight: 400, color: '#ddd'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({lang.caseTypes.arraigoSegundaOportunidad})</p>
				</div>
				<Spacer />
				<div>
					<p className='larger-font' style={{color: 'white'}}>{lang.caseTypeDescriptions.arraigoSegundaOportunidad}</p>
				</div>
			</button>

			<button className='button-row__large-btn bg-yellow'
				onClick={() => navigate('/arraigo-socioformativo')}
			>
				<div>
					<FontAwesomeIcon icon={faGraduationCap} className='round-icon-padding' style={{color: 'black'}}/>
					<span style={{ fontSize: '1.4rem', color: 'black' }}>{lang.arraigoSocioformativo}</span>
					<p style={{ fontSize: '1.1rem', fontWeight: 400, color: 'black'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({lang.caseTypes.arraigoSocioformativo})</p>
				</div>
				<Spacer />
				<div>
					<p className='larger-font' style={{color: 'black'}}>{lang.caseTypeDescriptions.arraigoSocioformativo}</p>
				</div>
			</button>

			<button className='button-row__large-btn bg-green'
				onClick={() => navigate('/arraigo-familiar')}
			>
				<div>
					<FontAwesomeIcon icon={faPeopleRoof} className='round-icon-padding' />
					<span style={{color: 'white'}}>{lang.arraigoFamiliar}</span>
					<p className='quad-title' style={{color: 'white'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({lang.caseTypes.arraigoFamiliar})</p>
				</div>
				<Spacer />
				<div>
					<p className='larger-font' style={{color: 'white'}}>{lang.caseTypeDescriptions.arragoFamiliar}</p>
				</div>
			</button>


		</div>
</div>

	);
}

export function WorkResidencyOptions() {
	const navigate = useNavigate();

	return (
	<div>
		<BackButton />
		<Spacer />
		<h2 className='secondary-title'>{lang.residencyOptions}</h2>
		<Spacer />
		<div className='button-row animated-div'>
			<button className='button-row__large-btn'
				onClick={() => navigate('/arraigo-social')}
			>
				{lang.arraigoSocial}
			</button>
			<button className='button-row__large-btn'
				onClick={() => navigate('/non-lucrative-residency-renewal')}
			>
				{lang.nonLucrativeRenewal}
			</button>
		</div>
	</div>

	);

}

export function AccountLanding() {
	const navigate = useNavigate();
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');
	const uid = auth.currentUser.uid;
	
	const [curUser, setCurUser] = useState(undefined)
	const [openedCases, setOpenedCases] = useState([]);
	const [presentedCases, setPresentedCases] = useState([])
	const [resolvedCases, setResolvedCases] = useState([]);



	useEffect( () => {
		const wrapper = async () => {
			const tmpUser = await getUser();
			setCurUser(tmpUser);
			const tmpCases = await getFirestoreCollection(`/users/${uid}/cases/`);
			const tmpOpenedCases = tmpCases.filter( (tmpCase) => {
				return (tmpCase.curStatus === "created");
			} )
			const tmpPresentedCases = tmpCases.filter( (tmpCase) => {
				return (tmpCase.curStatus === "submitted");
			} )
			const tmpResolvedCases = tmpCases.filter( (tmpCase) => {
				return (tmpCase.curStatus === "resolved");
			} )

			setOpenedCases(tmpOpenedCases);
			setPresentedCases(tmpPresentedCases);
			setResolvedCases(tmpResolvedCases);
				
			
		}
		wrapper();	
	}
	, []);

	return (
	<Box>
		<h2 className='primary-title'>{lang.openCases}</h2>
		<Spacer25 />
		<h3 className='tertiary-title'>{lang.availableCases}: {curUser?.availCases}</h3>

		<div className='button-row animated-div'>
		{
			openedCases.map( (openCase, index) => {
				console.log('openCase', openCase);
				const caseType = openCase.caseType;
				const caseIcon = caseIcons[caseType];
				const caseIconStyle = caseIconStyles[caseType];
				const caseIconPadding = caseIconPaddings[caseType];

				return (
					<button key={nanoid()}className='button-row__large-btn large-btn-fixed-width' onClick={() => navigate(`/cases/${openCase.id}`, {state: {openCase}})}>
						<div className=''>
							<div><FontAwesomeIcon icon={caseIcon} className={`${caseIconStyle} ${caseIconPadding}`} /></div>
						<Spacer25 />
							{lang.caseTypes[openCase.caseType]}
						</div>	

						<span className='normal-font'>
							{
								Intl.DateTimeFormat(lang.isoLang, { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(openCase.dateOpened))
							}
							<br />
						</span>
					</button>
				);
			}	)
		}
		<button className='button-row__large-btn new-btn' onClick={() => navigate('/available-procedures')}>+</button>

		</div>

		<h2 className='primary-title'>{lang.presentedCases}</h2>
		<Spacer25 />
		<div className='button-row animated-div'>
		{
			presentedCases.map( (openCase, index) => {
				const caseType = openCase.caseType;
				const caseIcon = caseIcons[caseType];
				const caseIconStyle = caseIconStyles[caseType];
				const caseIconPadding = caseIconPaddings[caseType];
				console.log('presentedCases', caseType);
				console.log('icon', caseIcons.auxToResidence)
				return (
					<button key={nanoid()}className='button-row__large-btn' onClick={() => navigate(`/cases/${openCase.id}`, {state: {openCase}})}>
						<div className=''>
							<FontAwesomeIcon icon={caseIcon} className={`${caseIconStyle} ${caseIconPadding}`} />
							{lang.caseTypes[openCase.caseType]}
						</div>	

						<span className='normal-font'>
							{
								Intl.DateTimeFormat(lang.isoLang, { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(openCase.dateOpened))
							}
							<br />
						</span>

					</button>
				);
			}	)
		}

		</div>
		<Spacer100 />
		<h2 className='primary-title'>{lang.resolvedCases}</h2>
		<Spacer25 />
		<div className='button-row animated-div'>
		{	
// 			resolvedCases.length > 0 ?
			resolvedCases.map( (resolvedCase, index) => (
				<button key={nanoid()}className='button-row__large-btn' onClick={() => navigate(`/cases/${resolvedCase.id}`)}>{resolvedCase.id}</button>
			))
// 			: <p>{lang.noResolvedCases}</p>
		}

		</div>
	</Box>
	);
}

export function AvailableProcedures(props) {
	const navigate = useNavigate();

	function handleProcedure(props) {
		curProcedure = props.procedure(props);
		console.log(curProcedure)
		props.setIsProcedureOpen(1);

	}

	return(
	<div>
		<h1 className='primary-title'>{lang.iWant}</h1>
		<Spacer />
		<h2 className='secondary-title'>{lang.immigrationCitizenship}</h2>
		<Spacer100 />

		<div className='button-row animated-div'>

		{
			<button className='button-row__large-btn button-row__two-per-row' 
				onClick={() => navigate('/aux-to-residence')}>
				<div>
				<FontAwesomeIcon icon={faClipboard} className='clipboard-icon-padding study-icon' />
				{lang.auxToResidence}
				</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.generalCategoriesDescription.auxToResidence}</p>
				</div>
			</button>
		}

		{
			<button className='button-row__large-btn button-row__two-per-row' 
				onClick={() => navigate('/student-stay-options')}>
				<div>
				<FontAwesomeIcon icon={faClipboard} className='clipboard-icon-padding study-icon' />
				{lang.stayInSpain}
				</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.generalCategoriesDescription.studyInSpain}</p>
				</div>

			</button>
		}

		{
			<button className='button-row__large-btn button-row__two-per-row'
				onClick={() => navigate('/residency-options')}>
					<div>
					<FontAwesomeIcon icon={faSun} className='live-icon round-icon-padding' />
					{lang.residencyInSpain}
					</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.generalCategoriesDescription.liveInSpain}</p>
				</div>

			</button>
		}

		{
			<button className='button-row__large-btn button-row__two-per-row'
				onClick={() => navigate('/spanish-citizenship')}>
					<div>
					<FontAwesomeIcon icon={faFlag} className='citizenship-icon flag-icon-padding' />
					{lang.becomeSpanish}
					</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.generalCategoriesDescription.becomeSpanish}</p>
				</div>

			</button>
		}

		{
			<button className='button-row__large-btn button-row__two-per-row'
				onClick={() => navigate('/regularization-2026')}>
					<div>
					<FontAwesomeIcon icon={faFlag} className='citizenship-icon flag-icon-padding' />
					{lang.regularization2026}
					</div>
				<Spacer100 />
				<div>
					<p className='p-gray larger-font'>{lang.generalCategoriesDescription.becomeSpanish}</p>
				</div>

			</button>
		}

		{
		<><p></p><p className='button-row__large-btn'>More case types in the works...</p></>
		}


		</div>

		<Spacer100 />
	{ /*
		<h2 className='secondary-title'>{lang.education}</h2>
		<Spacer />
		<div className='button-row animated-div'>
			<button className='button-row__large-btn'
				onClick={ () => navigate('/homologate-secondary-school') }>
				{lang.homologateSecondaryStudies}
			</button>
			<button className='button-row__large-btn'
				onClick={ () => navigate('/homologate-bachelors-degree') }>
				{lang.homolagateBachelors}
			</button>
			<button className='button-row__large-btn'
				onClick={ () => navigate('/homologate-masters-degree') }>
				{lang.homologateMasters}
			</button>
		</div>
	*/}

	</div>
	);

}

function SidebarLayout() {
	const navigate = useNavigate();
	const {currentUser} = useAuth();

	if (!currentUser) {
		navigate('/login');
// 		navigate('/coming-soon');
	}
	else{
		return(
			<div className='main-main'>
			<ScrollToTop />
			<NewHeader />
			<main className='main-menu'>
				<Spacer />
				<Outlet />
				<Spacer / >
			</main>
		</div>
		);
	}
}


export default function Main(){
//Now that we have navigator capabilities I don't think we need this. But we still may to manipulate some logic so just keep commented out for now.

// 	let [curProcedure, setCurProcedure] = React.useState(EmptyElement());
// 	let [availableProcedures, setAvailableProcedures] = React.useState(
// 		<AvailableProcedures setCurProcedure={setCurProcedure}  />
// 	);

// 	let [mainBody, setMainBody] = React.useState(
// 		<AvailableProcedures setCurProcedure={setCurProcedure}  />
// 	);
// 	let [isProcedureOpen, setIsProcedureOpen] = useState(0);


// 	<div className='main-main'>
// 		<Header />
// 		<main>
// 			<Spacer />
// 			<RouterProvider router={router} />
// 			<Spacer / >
// 		</main>
// 	</div>

	return(
		<RouterProvider router={router} />
	);
}
